module.exports = __webpack_public_path__ + "img/robot.8f07cfe5.svg";